/**
 * Opacity applied to the history chart body when a details-page filter is
 * active. History is always computed across all entities, so the chart is
 * dimmed to signal it does not reflect the current filter.
 */
const FILTERED_CHART_OPACITY = 0.3;

/**
 * Shared style for the history chart card body, used by the track and check
 * history cards so the dimmed-when-filtered treatment lives in one place.
 */
export const historyChartBodyStyle = (isFiltered: boolean) => ({
  height: '100%',
  opacity: isFiltered ? FILTERED_CHART_OPACITY : 1,
});
